import React from 'react';
import Reflux from 'reflux';
import {Button, message, Row, Col} from 'antd';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView, DisplayForm} from '../../components';
import {detail} from '../../service/thingsOrder';
import moment from 'moment';
import './table.css';
import qr from "qr-image";
import svgpath from "svgpath";

class ReturnGoodsPrint extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            // opts: ['回执单'],
            // type: ~~this.props.params.type,
            key: 0,
            selectedRowKeys: [],
            rows: [],
            resultData: {},
            total: 1,
            searchObj: {
                s: 10,
                p: 1
            },
            value: '',
            amountAll4: 0
            // distributor:JSON.parse(window.sessionStorage.getItem('distributor'))
        };
        this.pageChange = this.pageChange.bind(this);
        this.routeLeaveHook = this.routeLeaveHook.bind(this);
        this.goBack = this.goBack.bind(this);
        this.goView = this.goView.bind(this);
    };

    goBack() {
        hashHistory.goBack();
    }

    /*路径跳转*/
    goView(url) {
        hashHistory.push(url);
    };

    /*翻页*/
    pageChange(page, pageSize) {
        let self = this;
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}}, function () {
            self.initData();
        });
    }

    print = () => {

    };

    toFixed(d, n) {
        var s = n + "";
        if (!d) d = 0;
        if (s.indexOf(".") == -1) s += ".";
        s += new Array(d + 1).join("0");
        if (new RegExp("^(-|\\+)?(\\d+(\\.\\d{0," + (d + 1) + "})?)\\d*$").test(s)) {
            var s = "0" + RegExp.$2, pm = RegExp.$1, a = RegExp.$3.length, b = true;
            if (a == d + 2) {
                a = s.match(/\d/g);
                if (parseInt(a[a.length - 1]) > 4) {
                    for (var i = a.length - 2; i >= 0; i--) {
                        a[i] = parseInt(a[i]) + 1;
                        if (a[i] == 10) {
                            a[i] = 0;
                            b = i != 1;
                        } else break;
                    }
                }
                s = a.join("").replace(new RegExp("(\\d+)(\\d{" + d + "})\\d$"), "$1.$2");

            }
            if (b) s = s.substr(1);
            return (pm + s).replace(/\.$/, "");
        }
        return this + "";
    };


    /*获取列表数据*/
    initData() {
        let id = this.props.params.id;
        var realQuantityAll = 0;
        var amountAll = 0;
        var amountAll2 = 0;
        var amountAll3 = 0;
        var amountAll4 = 0; //扣点金额合计
        var returnaddress = "";
        var returnlinkman = "";
        var returnphone = "";
        const data = JSON.parse(window.sessionStorage.getItem('returngoodsprint'));
        if (data.gobackType != 'BPQ') {
            returnaddress = data.printAddress;
            returnlinkman = data.printLinkman;
            returnphone = data.printPhone;
        } else {
            returnaddress = "浙江省嘉兴市秀洲区中山西路2777号浙江天正智能电器有限公司";
            returnlinkman = "年介拽";
            returnphone = "15868072358";
        }
        for (let i = 0; i < data.lineList.length; i++) {
            data.lineList[i].id = i + 1;
            // realQuantityAll += data.lineList[i].gobackCount;
            realQuantityAll += data.lineList[i].realQuantity;
            amountAll += data.lineList[i].discountPrice;
            amountAll2 += data.lineList[i].discountMoney;
            data.lineList[i].discountPrice = data.lineList[i].discountPrice.toFixed(6);
            data.lineList[i].discountMoney = (data.lineList[i].discountPrice * data.lineList[i].realQuantity + 0.0000001).toFixed(2);
            //这是一个比较笨的方法，通过将小数乘以它的小数位数的10倍值，使其成为整数，通过整数的精确度方法四舍五入，然后在乘回原来的小数位
            //data.lineList[i].discountMoney = Math.round(data.lineList[i].discountPrice * data.lineList[i].realQuantity * 100 + 0.0000001) / 100;
            /*//解决tofixed在谷歌火狐中不兼容，四舍五入时5不进问题 (还有问题)
            var fixNum =(data.lineList[i].discountPrice * data.lineList[i].realQuantity+1).toFixed(2);
            data.lineList[i].discountMoney = new Number(fixNum - 1).toFixed(2);//四舍五入之后减1，再四舍*/
            amountAll3 = amountAll3 + Number(data.lineList[i].discountMoney);
            amountAll4 = amountAll4 + (data.lineList[i].sellPrice * data.lineList[i].realQuantity * data.lineList[i].refunds / 100);
        }
        var x = amountAll3.toFixed(2);
        var y = amountAll4.toFixed(2);
        var data1 = [...data.lineList];
        data1.push({
            id: 99999999,
            unit: '合计：',
            realQuantity: realQuantityAll,
            discountMoney: x
        });
        this.setState({
            rows: data1,
            resultData: data,
            amountAll4: y,
            returnaddress: returnaddress,
            returnlinkman: returnlinkman,
            returnphone: returnphone
        }, () => {
            const originPath = qr.svgObject(data.orderNumber).path; //  获得二维码的绘制路径
            const scaledPath = svgpath(originPath).scale(3, 3).toString();
            this.setState({
                path: scaledPath
            });
        });
    }

    //离开当前路由时，更新store
    routeLeaveHook(nextLocation) {
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.initData();
        //设置离开当前路由时的钩子函数
        // this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
    }

    render() {
        const {/*distributor, */rows, total, searchObj, resultData, type, path} = this.state;
        const tableViewProps = {
            loading: false,//更新表格数据中
            rowKey: 'id',
            pageParam: false,
            // pageParam: {
            //   total: total,
            //   current: searchObj.p,//当前页码
            //   pageSize: searchObj.s,//当前分页数
            //   onChange: this.pageChange
            // },
            columns: [
                {
                    title: '物料编码',
                    dataIndex: 'objCode',
                    width: 120
                },
                {
                    title: '产品名称',
                    dataIndex: 'objDescription'
                },
                {
                    title: '单位',
                    dataIndex: 'unit',
                    width: 60,
                    render: (text, record, index) => {
                        return <div>{text == 'EA' ? '只' : text}</div>
                    }
                },
                {
                    title: '数量',
                    dataIndex: 'realQuantity',
                    width: 60
                },
                {
                    title: '价格',
                    dataIndex: 'discountPrice',
                    width: 120
                },
                {
                    title: '金额(小计)',
                    dataIndex: 'discountMoney',
                    width: 120
                }
            ],
            paginationHide: true,
            rows
        };

        const h1 = {width: '100%', textAlign: 'center'}
        const shiwu = {textAlign: 'center'}
        const top = {width: '100%', textAlign: 'center', position: 'relative'}
        const printDate = moment(new Date()).format('YYYY/MM/DD');
        return (

            <div style={{padding: '20px', lineHeight: '30px'}}>
                <div style={{position: "absolute", top: "20px", right: "20px", zIndex: "99"}}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="80px" height="80px">
                        <path
                            d={path}
                        />
                    </svg>
                </div>

                <h1 style={h1}>{resultData.qualityBusiness == 'Q' ? '质量退货' : resultData.qualityBusiness == 'B' ? '商务退货' : '-'}</h1>
                <p style={{lineHeight: '10px'}}>&nbsp;</p>
                <Row style={{lineHeight: '18px', marginLeft: 14}}>
                    <Col span={7}>
                        <label>单号：{resultData.orderNumber}</label>
                    </Col>
                    <Col span={16}>
                        <label>退货方单位：{resultData.purchaseName}</label>
                    </Col>
                </Row>
                <Row style={{lineHeight: '18px', marginLeft: 14}}>
                    <Col span={7}>
                        <label>日期：{resultData.returnDate}</label>
                    </Col>
                    <Col span={16}>
                        <label>收货方地点：{resultData.gobackAddress}</label>
                    </Col>
                </Row>
                <Row style={{lineHeight: '18px', marginLeft: 14}}>
                    <Col span={7}>
                        <label>子库：{resultData.gobackStockeName}</label>
                    </Col>
                    <Col span={16}>
                        <label>是否已开票：{resultData.returnTypeName}</label>
                    </Col>
                </Row>
                <p style={{lineHeight: '10px'}}>&nbsp;</p>
                <div className='yourClass'><TableView {...tableViewProps} /></div>

                <p>{'　'}</p>
                <div><p
                    style={{
                        textAlign: 'left',
                        fontSize: '18px'
                    }}>此单据用于库房扫码退货出库使用，如需回购协议或回执单，请在退货界面打印对应单据</p>
                </div>
            </div>
        )
    }
}

export default ReturnGoodsPrint;


// WEBPACK FOOTER //
// ./src/routes/print/returnOutstorckPrint.js